import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './stores'
import {
  Button,
  Tabbar,
  TabItem,
  InfiniteScroll
} from 'mint-ui'
let mintUIComponents = [
  Button, Tabbar, TabItem
]
mintUIComponents.forEach(item => {
  Vue.component(item.name, item)
})
Vue.use(InfiniteScroll)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
